<script>
  /**
   * @type {string}
   */
  export let color = "#1C1C20";
</script>

<!-- 
    @component
     color: The color of the icon.
     colors can also be overridden by the css class `svg-color` and 
 -->

<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    class="svg-color"
    d="M1.4026 16C1.00823 16 0.67587 15.8648 0.405533 15.5945C0.135178 15.3241 0 14.9918 0 14.5974V1.4026C0 1.00823 0.135178 0.675861 0.405533 0.405506C0.67587 0.135169 1.00823 0 1.4026 0H8.02597V0.571429H1.4026C1.19481 0.571429 1.00433 0.658009 0.831169 0.831169C0.658009 1.00433 0.571429 1.19481 0.571429 1.4026V14.5974C0.571429 14.8052 0.658009 14.9957 0.831169 15.1688C1.00433 15.342 1.19481 15.4286 1.4026 15.4286H8.02597V16H1.4026ZM12.987 11.013L12.5455 10.6234L14.8831 8.28571H5.14286V7.71429H14.8831L12.5455 5.37662L12.961 4.96104L16 8.01299L12.987 11.013Z"
    fill={color}
  />
</svg>
